import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { baseUrl } from "../../constant"


const getToken = () => {
    const userToken = localStorage.getItem("userToken")
    return userToken ? `Bearer ${userToken}` : ''
}

export const loginApi = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        mode: 'cors',
        prepareHeaders: (headers) => {
            
            const token = getToken()
            if(token) {
                headers.set('Authorization', token)
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        newLogin: builder.mutation({
            query:(postData)=>({
                url:"login",
                method:"POST",
                body: postData
            })
        }),
    })
    })

    export const { useNewLoginMutation } = loginApi